export const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const hiragana = 'あかさたなはまやらわ';

export const initialString = alphabet + hiragana;
